function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { SvgIcon } from '@material-ui/core';
export default function BroadbandIcon(props) {
  let output = /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 512 512"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "_15-wifi",
    "data-name": "15-wifi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "256",
    cy: "340",
    r: "38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m489.345 106.655a330 330 0 0 0 -466.69 0 6 6 0 0 0 0 8.485l28.284 28.284a6 6 0 0 0 8.485 0 278 278 0 0 1 393.154 0 6 6 0 0 0 8.486 0l28.283-28.284a6 6 0 0 0 -.002-8.485z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.936 213.064a5.982 5.982 0 0 0 4.242-1.757l28.285-28.285a6 6 0 0 0 0-8.485 234 234 0 0 0 -330.926 0 6 6 0 0 0 0 8.485l28.285 28.285a6 6 0 0 0 8.485 0 182 182 0 0 1 257.386 0 5.976 5.976 0 0 0 4.243 1.757z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m321.055 280.946a5.986 5.986 0 0 0 4.243-1.757l28.283-28.289a6 6 0 0 0 0-8.486 138 138 0 0 0 -195.16 0 6 6 0 0 0 0 8.486l28.279 28.289a6 6 0 0 0 8.486 0 86 86 0 0 1 121.625 0 5.976 5.976 0 0 0 4.244 1.757z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392 404h-272a36.04 36.04 0 0 0 -36 36v32a36.04 36.04 0 0 0 36 36h272a36.04 36.04 0 0 0 36-36v-32a36.04 36.04 0 0 0 -36-36zm12 68a12.013 12.013 0 0 1 -12 12h-272a12.013 12.013 0 0 1 -12-12v-32a12.013 12.013 0 0 1 12-12h272a12.013 12.013 0 0 1 12 12z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "256",
    cy: "456",
    r: "12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "305.304",
    cy: "456",
    r: "12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "354.609",
    cy: "456",
    r: "12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "206.696",
    cy: "456",
    r: "12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "157.391",
    cy: "456",
    r: "12"
  }))));
  return output;
}
